<script setup>
import { computed, onBeforeMount, onBeforeUnmount, ref } from 'vue'
import {
  mdiChartTimelineVariant,
} from '@mdi/js'
import SectionMain from '@/components/SectionMain.vue'
import CardBoxComponentEmpty from '@/components/CardBoxComponentEmpty.vue'
import CardBoxTask from '@/components/Tasks/CardBoxTask.vue'
import CardBoxNotification from '@/components/Notifications/CardBoxNotification.vue'
import LayoutAuthenticated from '@/layouts/LayoutAuthenticated.vue'
import SectionTitleLineWithButton from '@/components/SectionTitleLineWithButton.vue'
// import { useI18n } from 'vue-i18n'
import { useTasksStore } from '@/stores/tasks'
import { useUserStore } from '@/stores/user_store'
import { useNotificationsStore } from '@/stores/notifications'

// const { t } = useI18n()
const tasksStore = useTasksStore()
const userStore = useUserStore()
const notificationsStore = useNotificationsStore()
const intervalId = ref(null)

async function fetchNotifications() {
  await notificationsStore.fetchNotifications()
    .then((results)=> {
      setTimeout(()=>{
        let result = results.filter(item => !item.read).map(item => item.id);
        if (result.length){
          notificationsStore.readNotifications({
            notification_ids: result
          })
        }
      }, 10000)
    })
}

onBeforeMount(async() => {
  await tasksStore.fetchActiveTasks()
  if (userStore.can("notifications")) {
    await fetchNotifications()
  intervalId.value = setInterval(
      async () => {
        await fetchNotifications()
    }, 15000
  );
  }
})
onBeforeUnmount(async() => {
  clearTimeout(intervalId.value)
})


const activeTasks = computed(() => tasksStore.activeTasks)
const notifications = computed(() => notificationsStore.notifications)

</script>

<template>
  <LayoutAuthenticated>
    <SectionMain>
      <SectionTitleLineWithButton :icon="mdiChartTimelineVariant" title="Активные задачи" main />
        <template v-if="activeTasks.length > 0">
          <CardBoxTask
            v-for="item in activeTasks"
            :key="item.id"
            :task="item"
            :can-take="false"
            class="mb-2"
          ></CardBoxTask>
        </template>
        <CardBoxComponentEmpty v-else >Нет активных задач</CardBoxComponentEmpty>
        <SectionTitleLineWithButton 
          v-if="notifications.length > 0 && userStore.can('notifications')"
          :icon="mdiChartTimelineVariant"
          title="Уведомления"
          class="mt-5"
          main
        />
        <template v-if="notifications.length > 0 && userStore.can('notifications')">
          <CardBoxNotification
            v-for="item in notifications"
            :key="item.id"
            :notification="item"
            class="mb-2"
          ></CardBoxNotification>
        </template>
    </SectionMain>
  </LayoutAuthenticated>
</template>
